import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import ProfileDetailsOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('profile-details', {
  template: require('./template.html'),
  name: 'profile-details',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentSite',
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    profileData() {
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.profiles;
      const profiles = enabled ? (enabled.published || []) : [];
      const ref = this.droplet.ref;
      const item = ref && enabled ? _.find(profiles, p => p._id === ref) : false;
      return item ||
      {
        name: 'Profile Name',
        description: 'No profile linked.',
        created: new Date().toISOString(),
        image: `${process.env.S3_ASSETS_URL}mock-images/default-images/mock-profile.svg`,
      };
    },
    hasContact() {
      return this.profileData.address ||
        this.profileData.phone ||
        this.profileData.email ||
        this.profileData.website;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzProfile-details' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        boxWidthTop: null,
        boxWidthBottom: null,
        boxWidthRight: null,
        boxWidthLeft: null,
        socialBorderTrRadius: null,
        socialBorderTlRadius: null,
        socialBorderBrRadius: null,
        socialBorderBlRadius: null,
        imagePaddingTop: null,
        imagePaddingBottom: null,
        imagePaddingLeft: null,
        imagePaddingRight: null,
        nameLetterSpacing: null,
        contactLetterSpacing: null,
        contactSize: null,
        nameSize: null,
        lineWidth: null,
        'box-shadow': null,
        'font-size': null,
        'padding-left': null,
        'padding-right: ': null,
        'padding-top:': null,
        'padding-bottom': null,
        'letter-spacing': null,
        'border-top-left-radius': null,
        'border-top-right-radius': null,
        'border-bottom-left-radius': null,
        'border-bottom-right-radius': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    ProfileDetailsOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzProfile-details',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    globalOpenModal(open) {
      if (!open) {
        // we trigger the rerender here if user is adding new dynamic data
        this.destroyPlugin();
        this.initPlugin();
      }
    },
    'droplet.ref': function onNewReference() {
      setTimeout(() => {
        this.destroyPlugin();
        this.initPlugin();
      }, 500);
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.initPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    initPlugin() {
      const ref = this.$refs.profileDetailsGallery;
      if (ref) {
        const $droplet = $(this.$refs.profileDetailsGallery);
        $droplet.drzImageGallery();
      }
    },
    destroyPlugin() {
      const ref = this.$refs.profileDetailsGallery;
      if (ref) {
        const $droplet = $(this.$refs.profileDetailsGallery);
        if ($droplet.drzImageGallery.destroy) {
          $droplet.drzImageGallery.destroy($droplet);
        }
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/profile-details/index.js